import React from "react";
import PropTypes from "prop-types";
import { Line } from "react-chartjs-2";
import { Paper, Typography } from "@material-ui/core";

const Chart = ({ data, title }) => {
  return (
    <Paper>
      <Typography
        style={{ padding: "10px 0", textAlign: "center" }}
        variant="h5"
        color="primary"
      >
        {title}
      </Typography>
      <Line
        data={{
          labels: data.map((item) => item.country),
          datasets: [
            {
              data: data.map((item) => item.hits),
              label: "Clicks",
              borderColor: "rgba(255, 99, 132, 1)",
              pointStyle: "circle",
              pointHoverBorderWidth: 3,
              pointBackgroundColor: "rgba(255, 99, 132, 0.5)",
              pointBorderColor: "rgba(255, 99, 132, 1)",
              pointHoverRadius: 15,
              pointRotation: 5,
              pointRadius: 5,

              fill: false,
            },
            {
              data: data.map((item) => item.impressions),
              label: "Impressions",
              borderColor: "rgba(75, 192, 192, 1)",
              pointStyle: "circle",
              pointHoverBorderWidth: 3,
              pointBackgroundColor: "rgba(75, 192, 192, 0.5)",
              pointBorderColor: "rgba(75, 192, 192, 1)",
              pointHoverRadius: 15,
              pointRotation: 5,
              pointRadius: 5,
              fill: false,
            },
          ],
        }}
        options={{
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  min: 0,
                  beginAtZero: true,
                },
              },
            ],
          },
        }}
      />
    </Paper>
  );
};

Chart.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};

export default React.memo(Chart);
